import { RangeType } from '../constants-types/Enums';

type MinMaxPrimitive = {
    min: number;
    max: number;
};

export class MinMax {
    min: number;
    max: number;

    constructor(
        obj: MinMaxPrimitive,
        validation?: {
            minAcceptableValue: number;
            maxAcceptableValue?: number;
            minRange?: number;
        }
    ) {
        Object.assign(this, obj);
        if (validation !== undefined) {
            this.validateValues(
                validation.minAcceptableValue,
                validation.maxAcceptableValue,
                validation.minRange
            );
        }
    }

    /**
     * Enforce values to min/max end points and enforce a minimum delta
     *
     * @param minAcceptableValue
     * @param maxAcceptableValue
     * @param minRange
     */
    private validateValues(
        minAcceptableValue: number,
        maxAcceptableValue: number,
        minRange: number
    ): void {
        let newMin = Math.max(
            Math.min(this.min, maxAcceptableValue),
            minAcceptableValue
        );
        let newMax = Math.max(
            Math.min(this.max, maxAcceptableValue),
            minAcceptableValue
        );

        if (Math.abs(newMax - newMin) < minRange) {
            if (newMin === minAcceptableValue) {
                newMax = newMin + minRange;
            } else if (newMax === maxAcceptableValue) {
                newMin = newMax - minRange;
            }
        }

        this.min = newMin;
        this.max = newMax;
    }

    get rangeType(): RangeType {
        if (this.min < 0 && this.max > 0) {
            return RangeType.CrossesMidpoint;
        }
        if (Math.ceil(this.min) === Math.ceil(this.max)) {
            return RangeType.SingleZone;
        }
        return RangeType.DoesNotCrossMidpoint;
    }

    get delta(): number {
        return this.max - this.min;
    }

    get midpoint(): number {
        return this.min + this.delta / 2;
    }
}

export type ChecklistItem = {
    name: string;
    isComplete: boolean;
};
